module.exports = __webpack_public_path__ + "static/delete_api_key_confirmation-48748acc26be3c5cc1b4c4213be3149b.png";